/** Values shared by the client and the server. Business-tunable numbers live in
 *  the `app_setting` table instead — these are structural constants only. */

export const API_BASE_PATH = '/api/v1'

/**
 * The desktop app's surface. Versioned independently of the browser API
 * because old app builds live on people's disks forever — once this ships, the
 * contract can only be added to, never changed.
 */
export const PUBLIC_API_BASE_PATH = '/api/public/v1'

/** The application bills in USD and charges in IDR. */
export const BILLING_CURRENCY = 'USD'
export const PAYMENT_CURRENCY = 'IDR'

/** Every timestamp shown to a user, and every usage date range, is resolved in
 *  Western Indonesian Time. V1 used UTC here and drifted the day boundary by 7 hours. */
export const BUSINESS_TIMEZONE = 'Asia/Jakarta'

export const USAGE_PAGE_SIZES = [10, 30, 50] as const
export const DEFAULT_USAGE_PAGE_SIZE = 10
export const MAX_USAGE_PAGE_SIZE = 100

/** LiteLLM prefixes a key alias with the owner's email in some legacy records. */
export const KEY_ALIAS_SEPARATOR = '|'

export const ERROR_CODES = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  RATE_LIMITED: 'RATE_LIMITED',
  NOT_PROVISIONED: 'NOT_PROVISIONED',
  UPSTREAM_FAILED: 'UPSTREAM_FAILED',
  INTERNAL: 'INTERNAL',
} as const

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES]
